import React from 'react'
import { useMemo, useRef } from 'sb-hooks'
import cx from 'classnames'
import { useRect } from '@reach/rect'

import s from './Collapsible.scss'


type CollapsibleProps = {
  className?: string
  id?: string
  contentClassName?: string
  opened: boolean
}

const Collapsible: React.FunctionComponent<CollapsibleProps> = (props) => {
  const { children, className, id, contentClassName, opened } = props

  const ref = useRef()
  const rect = useRect(ref, true)

  const rootClassName = cx(s.collapsible, className)

  const style = useMemo(
    () => ({ height: !opened ? 0 : ((rect && rect.height) || 'auto') }),
    [ rect, opened ]
  )

  return (
    <div id={id} className={rootClassName} style={style}>
      <div ref={ref} className={contentClassName}>
        {children}
      </div>
    </div>
  )
}


export default Collapsible
